const prefix = 'organization/'

const type = {
    LOAD_LIST_ORGANIZATIONS: prefix + 'load_list_organizations',
    LOAD_LIST_ORGANIZATIONS_SUCCESS: prefix + 'load_list_organizations_success',
    LOAD_LIST_ORGANIZATIONS_FAILED: prefix + 'load_list_organizations_failed',

    ADD_ORGANIZATIONS: prefix + 'ADD_ORGANIZATIONS',
    ADD_ORGANIZATIONS_SUCCESS: prefix + 'ADD_ORGANIZATIONS_SUCCESS',
    ADD_ORGANIZATIONS_FAILED: prefix + 'ADD_ORGANIZATIONS_FAILED',

    SET_ORGANIZATION_EDITING: prefix + 'SET_ORGANIZATION_EDITING',
    PRE_ADD_ORGANIZATION: prefix + 'pre_add_organiztion',
    UPDATE_CURRENT_ORGANIZATION: prefix + 'update_current_organization',

    SAVE_ORGANI_CURRENT: prefix + 'SAVE_ORGANI_CURRENT',
    // UPDATE_CURRENT_ORGANIZATION_SUCCESS : prefix + 'update_current_organization_success',
    // UPDATE_CURRENT_ORGANIZATION_FAILED: prefix + 'update_current_organization_failed' ,

    UPDATE_ORGANIZATION: prefix + 'update_organization',
    UPDATE_ORGANIZATION_SUCCESS: prefix + 'update_organization_success',
    UPDATE_ORGANIZATION_FAILED: prefix + 'update_organization_failed',

    REMOVE_ORGANIZATION: prefix + 'remove_organization',
    REMOVE_ORGANIZATION_SUCCESS: prefix + 'remove_organization_success',
    REMOVE_ORGANIZATION_FAILED: prefix + 'remove_organization_failed',

    CREATE_ORGANIZATION: prefix + 'create_organization',
    GET_CURENT_ORGANIZATION: prefix + 'get_current_organization',

    //for Modal
    SHOW_MODAL_ORGANIZATIONS: prefix + 'show_modal_rganization',
    HIDE_MODAL_ORGANIZATIONS: prefix + 'hide_modal_rganization',
    CHANGE_MODAL_TITLE_ORGANIZATIONS: prefix + 'change_modaltitle_rganization',
    CHANGE_MODAL_COMPONENT_ORGANIZATIONS:
        prefix + 'change_modal_component_organizations',

    SHOW_MODAL_USERS: prefix + 'show_modal_user',
    HIDE_MODAL_USERS: prefix + 'hide_modal_user',
    CHANGE_MODAL_TITLE_USERS: prefix + 'change_modaltitle_user',
    CHANGE_MODAL_COMPONENT_USERS: prefix + 'change_modal_component_user',

    GET_BOSS: prefix + 'get_list_boss_request',
    GET_BOSS_SUCCESS: prefix + 'get_list_boss_request_success',
    GET_BOSS_FAILED: prefix + 'get_list_boss_request_failed',

    GET_LIST_DEPUTY: prefix + 'get_list_deputy_request',
    GET_LIST_DEPUTY_SUCCESS: prefix + 'get_list_deputy_request_success',
    GET_LIST_DEPUTY_FAILED: prefix + 'get_list_deputy_request_failed',

    GET_LIST_MEMBER: prefix + 'get_list_member_request',
    GET_LIST_MEMBER_SUCCESS: prefix + 'get_list_member_request_success',
    GET_LIST_MEMBER_FAILED: prefix + 'get_list_member_request_failed',

    GET_LIST_USER_IN_ORGANI: prefix + 'get_list_user_in_organi_request',
    GET_LIST_USER_IN_ORGANI_SUCCESS: prefix + 'get_list_user_in_organi_success',
    GET_LIST_USER_IN_ORGANI_FAILED: prefix + 'get_list_user_in_organi_failed',

    SEARCH_MEMBER: prefix + 'search_member',
    SEARCH_MEMBER_SUCCESS: prefix + 'search_member_success',
    SEARCH_MEMBER_FAILED: prefix + 'search_member_failed',

    AVATAR_ORGANIZATION: prefix + 'avatar_organization',
    GET_LIST_ORG_QUERY_BY_ID: prefix + 'get_list_org_query_by_id',
    GET_LIST_ORG_QUERY_BY_ID_DONE: prefix + 'get_list_org_query_by_id_done',
    UPDATE_LIST_ORG_QUERY: prefix + 'update_list_org_query',
    DELÊT_LIST_ORG_UPDATE: prefix + ' delete_list_org_update',

    GET_BOSS_INFO: prefix + 'get_boss_info',
    GET_BOSS_INFO_SUCCESS: prefix + 'get_boss_info_success',
    GET_BOSS_INFO_FAILED: prefix + 'get_boss_info_failed',

    CREATE_AVATAR_ORGANIZATION: prefix + 'create_avatar_organization',
    CREATE_AVATAR_ORGANIZATION_SUCCESS:
        prefix + 'create_avatar_organization_success',

    SHOW_MODAL_INFO_ORGANIZATION: prefix + 'show_modal_info_organization',
    HIDE_MODAL_INFO_ORGANIZATIONS: prefix + 'hide_modal_info_organization',

    GET_LIST_ROLES: prefix + 'get_list_role',
    GET_LIST_ROLES_SUCCESS: prefix + 'get_list_role_success',

    GET_LIST_ACTION_BY_ID: prefix + 'get_list_action_by_id',
    GET_LIST_ACTION_BY_ID_SUCCESS: prefix + 'get_list_action_by_id_success',

    UPDATE_ROLE_OF_USER_IN_ORGANI: prefix + 'update_role',
    GET_ORG_BY_ID: prefix + 'GET_ORG_BY_ID',
    GET_ORG_BY_ID_DONE: prefix + 'GET_ORG_BY_ID_DONE',
}

const loadType = {
    GET_ALL: -1,
    GET_NOT_DELETED: 0,
    GET_DELETED: 1,
}

const action = {
    getOrgById: lst => {
        return {
            type: type.GET_ORG_BY_ID,
            payload: {
                lst,
            },
        }
    },
    getOrgByIdDone: data => {
        return {
            type: type.GET_ORG_BY_ID_DONE,
            payload: {
                data,
            },
        }
    },
    loadListOrganization: loadType => {
        return {
            type: type.LOAD_LIST_ORGANIZATIONS,
            payload: {
                loadType,
            },
        }
    },

    loadListOrganizationSuccess: organizations => {
        return {
            type: type.LOAD_LIST_ORGANIZATIONS_SUCCESS,
            payload: {
                organizations,
            },
        }
    },

    loadListOrganizationFailed: error => {
        return {
            type: type.LOAD_LIST_ORGANIZATIONS_FAILED,
            payload: {
                error,
            },
        }
    },

    preAddOrgani: () => {
        return {
            type: type.PRE_ADD_ORGANIZATION,
            payload: {},
        }
    },
    saveOrganiCurrent: () => {
        return {
            type: type.SAVE_ORGANI_CURRENT,
            payload: {},
        }
    },

    addOrganization: organization => {
        return {
            type: type.ADD_ORGANIZATIONS,
            payload: {
                organization,
            },
        }
    },

    addOrganizationSuccess: organization => {
        return {
            type: type.ADD_ORGANIZATIONS_SUCCESS,
            payload: {
                organization,
            },
        }
    },

    addOrganizationFailed: error => {
        return {
            type: type.ADD_ORGANIZATIONS_FAILED,
            payload: {
                error,
            },
        }
    },

    setOrganizationEditing: organization => {
        return {
            type: type.SET_ORGANIZATION_EDITING,
            payload: {
                organization,
            },
        }
    },

    updateOrganization: (oid, organization) => {
        return {
            type: type.UPDATE_ORGANIZATION,
            payload: {
                oid,
                organization,
            },
        }
    },

    updateOrganizationSuccess: (oid, organization) => {
        return {
            type: type.UPDATE_ORGANIZATION_SUCCESS,
            payload: {
                organization,
                oid,
            },
        }
    },

    updateOrganizationFailed: error => {
        return {
            type: type.UPDATE_ORGANIZATION_FAILED,
            payload: {
                error,
            },
        }
    },

    updateCurrentOrganization: object => {
        return {
            type: type.UPDATE_CURRENT_ORGANIZATION,
            payload: {
                object,
            },
        }
    },

    removeOrganization: oid => {
        return {
            type: type.REMOVE_ORGANIZATION,
            payload: {
                oid,
            },
        }
    },

    removeOrganizationSuccess: oid => {
        return {
            type: type.REMOVE_ORGANIZATION,
            payload: {
                oid,
            },
        }
    },

    removeOrganizationSucess: oid => {
        return {
            type: type.REMOVE_ORGANIZATION_SUCCESS,
            payload: {
                oid,
            },
        }
    },

    createOrganization: organization => {
        return {
            type: type.CREATE_ORGANIZATION,
            payload: {
                organization,
            },
        }
    },

    getCurrentOrganization: oid => {
        return {
            type: type.GET_CURENT_ORGANIZATION,
            payload: {
                oid,
            },
        }
    },

    showModal: () => ({
        type: type.SHOW_MODAL_ORGANIZATIONS,
    }),

    hideModal: () => ({
        type: type.HIDE_MODAL_ORGANIZATIONS,
    }),

    showModalUsers: () => ({
        type: type.SHOW_MODAL_USERS,
    }),

    hideModalUsers: () => ({
        type: type.HIDE_MODAL_USERS,
    }),

    showModalInfo: () => ({
        type: type.SHOW_MODAL_INFO_ORGANIZATION,
    }),

    hideModalInfo: () => ({
        type: type.HIDE_MODAL_INFO_ORGANIZATIONS,
    }),

    changeModalTitle: (title, titleButtonModal) => ({
        type: type.CHANGE_MODAL_TITLE_ORGANIZATIONS,
        payload: {
            title,
            titleButtonModal,
        },
    }),

    changeModalComponent: component => ({
        type: type.CHANGE_MODAL_COMPONENT_ORGANIZATIONS,
        payload: {
            component,
        },
    }),

    changeModalTitleListUser: title => ({
        type: type.CHANGE_MODAL_TITLE_USERS,
        payload: {
            title,
        },
    }),
    getListBoss: array => ({
        type: type.GET_BOSS,
        payload: {
            array,
        },
    }),

    getListBossSuccess: data => ({
        type: type.GET_BOSS_SUCCESS,
        payload: {
            data,
        },
    }),

    getListDeputy: array => ({
        type: type.GET_LIST_DEPUTY,
        payload: {
            array,
        },
    }),

    getListDeputySuccess: data => ({
        type: type.GET_LIST_DEPUTY_SUCCESS,
        payload: {
            data,
        },
    }),

    getListMember: array => ({
        type: type.GET_LIST_MEMBER,
        payload: {
            array,
        },
    }),

    getListMemberSuccess: data => ({
        type: type.GET_LIST_MEMBER_SUCCESS,
        payload: {
            data,
        },
    }),

    getLisMemberFailed: error => ({
        type: type.GET_LIST_MEMBER_SUCCESS,
        payload: {
            error,
        },
    }),

    getListUserInOrgani: array => ({
        type: type.GET_LIST_USER_IN_ORGANI,
        payload: {
            array,
        },
    }),

    getListUserInOrganiSuccess: data => ({
        type: type.GET_LIST_USER_IN_ORGANI_SUCCESS,
        payload: {
            data,
        },
    }),

    getListUserInOrganiFailed: error => ({
        type: type.GET_LIST_USER_IN_ORGANI_FAILED,
        payload: {
            error,
        },
    }),
    searchMember: (keyword, typeUser) => ({
        type: type.SEARCH_MEMBER,
        payload: {
            keyword,
            typeUser,
        },
    }),
    searchMemberSuccess: data => ({
        type: type.SEARCH_MEMBER_SUCCESS,
        payload: {
            data,
        },
    }),
    searchMemberFailed: err => ({
        type: type.SEARCH_MEMBER_FAILED,
        payload: {
            err,
        },
    }),
    avatarOrganization: url => ({
        type: type.AVATAR_ORGANIZATION,
        payload: {
            url,
        },
    }),
    getListOrgQueryById: lst => {
        return {
            type: type.GET_LIST_ORG_QUERY_BY_ID,
            payload: {
                lst,
            },
        }
    },
    getListOrgQueryByIdDone: data => {
        return {
            type: type.GET_LIST_ORG_QUERY_BY_ID_DONE,
            payload: {
                data,
            },
        }
    },
    create_avatar_organiztion: data => ({
        type: type.CREATE_AVATAR_ORGANIZATION,
        payload: {
            data,
        },
    }),
    create_avatar_organiztion_success: url => ({
        type: type.CREATE_AVATAR_ORGANIZATION_SUCCESS,
        payload: {
            url,
        },
    }),
    updateListOrgQuery: data => {
        return {
            type: type.UPDATE_LIST_ORG_QUERY,
            payload: {
                data,
            },
        }
    },
    deleteListOrgQuery: () => {
        return {
            type: type.DELÊT_LIST_ORG_UPDATE,
        }
    },
    getBossInfo: uid => ({
        type: type.GET_BOSS_INFO,
        payload: {
            uid,
        },
    }),
    getBossInfoSuccess: data => ({
        type: type.GET_BOSS_INFO_SUCCESS,
        payload: {
            data,
        },
    }),
    getBossInfoFailed: err => ({
        type: type.GET_BOSS_INFO_FAILED,
        payload: {
            err,
        },
    }),

    getListRole: () => {
        return {
            type: type.GET_LIST_ROLES,
            payload: {},
        }
    },
    getListRolesSuccess: roles => {
        return {
            type: type.GET_LIST_ROLES_SUCCESS,
            payload: {
                roles,
            },
        }
    },
    getListActionById: idRole => {
        return {
            type: type.GET_LIST_ACTION_BY_ID,
            payload: {
                idRole,
            },
        }
    },

    getListActionByIdSuccess: data => {
        return {
            type: type.GET_LIST_ACTION_BY_ID_SUCCESS,
            payload: {
                data,
            },
        }
    },
    updateRoleOfUserInOrgani: object => {
        return {
            type: type.UPDATE_ROLE_OF_USER_IN_ORGANI,
            payload: {
                object,
            },
        }
    },
}

export default {
    type,
    action,
    loadType,
}
